import { useCallback } from "react";

import type { GetMenuAnchor, GetMenuBoundary } from "components/v2/Select/types";

export function usePackingListMenuLayout(): GetMenuAnchor {
  return useCallback((container: HTMLElement) => {
    const dimensionUnit = container.closest<HTMLElement>(".rfv2-packing-list-table__dimension-unit");
    const currencySelect = container.closest<HTMLElement>(".rfv2-packing-list-table__currency-select");
    const weightUnit = container.closest<HTMLElement>(".rfv2-packing-list-table__weight-unit");
    const temperatureCell = container.closest<HTMLElement>(".rfv2-packing-list-table__cell--temperature");
    const dangerousCell = container.closest<HTMLElement>(".rfv2-packing-list-table__cell--dangerous");
    const tableCell = container.closest<HTMLElement>(".rfv2-packing-list-table__cell");
    const control = container.querySelector<HTMLElement>(".cb-select__control");

    if (dimensionUnit) {
      return dimensionUnit.parentElement ?? dimensionUnit;
    }
    if (currencySelect) {
      return control ?? container;
    }
    if (weightUnit) {
      return tableCell ?? weightUnit;
    }
    if (temperatureCell) {
      return temperatureCell;
    }
    if (dangerousCell) {
      return dangerousCell;
    }
    if (tableCell) {
      const isOnlySelectInCell =
        tableCell.querySelectorAll(":scope > .selectV2").length === 1 && tableCell.childElementCount === 1;
      return isOnlySelectInCell ? tableCell : control ?? container;
    }
    return control ?? container;
  }, []);
}

export function usePackingListMenuBoundary(): GetMenuBoundary {
  return useCallback((container: HTMLElement) => {
    const table = container.closest<HTMLElement>(".rfv2-packing-list-table");
    if (!table) return null;

    const tableRight = table.getBoundingClientRect().right;
    const scrollContainer = table.parentElement?.closest<HTMLElement>(".rfv2-packing-list-table-scroll");
    const scrollRight = scrollContainer?.getBoundingClientRect().right;

    return scrollRight != null ? Math.min(tableRight, scrollRight) : tableRight;
  }, []);
}
